// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__NBkTP","header":"Projects_header__WjQKX","cardsContainer":"Projects_cardsContainer__BtryO"};